import React from "react";
import { NavLink } from "react-router-dom";

import Main from "../layouts/Main";

import { MainContent, Sidebar } from "../components/Services";
import PageBanner from "../components/PageBanner";

const Services = () => (
  <Main>
    <PageBanner title="Services" />
    <section className="ls s-py-60 s-py-md-90 s-py-xl-120  c-gutter-60 services-page">
      <div className="container">
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6 d-flex">
            <div>
              <img src={`${process.env.PUBLIC_URL}/assets/images/jmty-event.jpg`} alt=""/>
            </div>
            <div className="icon-box">
              <h6 className="underline mt-3">
                <NavLink to="/prospective-international-student">
                  Prospective International Student
                </NavLink>
              </h6>
              <p>
                Are you thinking about getting a U.S. degree but don’t know how
                to go about it? Let us work with you through the entire process.
              </p>
              <NavLink
                to="/prospective-international-student"
                className="btn btn-small btn-maincolor"
              >
                More Details
              </NavLink>
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-6 d-flex">
            <div>
              <img src={`${process.env.PUBLIC_URL}/assets/images/img1.jpg`} alt=""/>
            </div>
            <div className="icon-box">
              <h6 className="underline mt-3">
                <NavLink to="/current-international-student">
                  Current International Student
                </NavLink>
              </h6>
              <p>
                Are you an international student looking for an internship or a
                full-time job in the US? Or do you need general career advice?
                We were in your shoes only a few years ago and will be glad to
                help you.
              </p>
              <NavLink
                to="/current-international-student"
                className="btn btn-small btn-maincolor"
              >
                More Details
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Main>
);

export default Services;
